import {
  ReportActions,
  COST_CENTER_REPORT_SUCCESS,
  COST_CENTER_REPORT_LOADING,
} from 'action-creators/costCenterReport';
import { RESET } from 'action-creators/generic';

export interface CostCenterReportState {
  reportSummary?: Response;
  isLoading: boolean;
}

const initialState: CostCenterReportState = {
  reportSummary: undefined,
  isLoading: false,
};

const reducer = (state = initialState, action: ReportActions): CostCenterReportState => {
  switch (action.type) {
    case COST_CENTER_REPORT_SUCCESS:
      return {
        ...state,
        reportSummary: action.data,
        isLoading: false,
      };
    case COST_CENTER_REPORT_LOADING:
      return {
        ...state,
        isLoading: action.loading,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
